// The map client (renderer, input, movement, camera, network), loaded by app.js as one import ('/deck/index.js');
// the modules import each other by relative path.
export { parseMap, composeArt } from './map.js';
export { keepPlacesLocalized, placeName } from './places.js';
export { collider, SEA_MARGIN, BODY, feet } from './collide.js';
export { createMover } from './move.js';
export { createCamera } from './camera.js';
export { watchHud } from './hud.js';
export { bindInput } from './input.js';
export { createNet } from './net.js';
export { inEdge, portalTo } from './moor.js';
/** The renderer (~1.4 MB with Phaser), downloaded while the join card is up. */
export const loadScene = () => import('./scene.js');
/** The phone's stick (摇杆), drawn on the map: loaded once the scene is up. */
export const loadStick = () => import('./stick.js');
/** 房间 on a phone (public/rooms.js): the rooms list drawn with the engine UI kit, loaded the first time it opens. */
export const loadRooms = () => import('./rooms-view.js');

export { initMapEditor } from './map-editor.js';
export { refreshMap } from './map-editor-view.js';

// dev only: ?uidemo=scroll shows the kit's ScrollList over the map (deck/ui/scroll-demo.js)
if (/[?&]uidemo=scroll\b/.test(location.search) && !/^deck(-cn)?\.botiverse\.dev$/.test(location.hostname)) import('./ui/scroll-demo.js').catch((e) => console.error('ui scroll demo', e));
// dev only: ?uidemo=textfield shows the kit's TextField over the map (deck/ui/textfield-demo.js)
if (/[?&]uidemo=textfield\b/.test(location.search) && !/^deck(-cn)?\.botiverse\.dev$/.test(location.hostname)) import('./ui/textfield-demo.js').catch((e) => console.error('textfield demo', e));
